import {
  ANI_ROUTER,
  CLIENT,
  DATE_RANGE_ROUTER,
  DAY_OF_WEEK_ROUTER,
  DNIS_ROUTER,
  HUNT_GROUP,
  MATCH_START,
  NUMBER_PLAN,
  PLAY,
  PLUGIN,
  QUEUE,
  REMOTE,
  ROUTE_START,
  SAY,
  SCRIPT,
  SIP,
  SIP_GATEWAY,
  SUB_FLOW,
  TEAM,
  TIME_RANGE_ROUTER,
  VOICEMAIL,
  ZONE_ROUTER,
} from "callable-data-objects";
import { useAPI } from "Providers/APIProvider";
import { ROLES } from "../constants";

export default function useCheckRole() {
  const { keycloak } = useAPI();

  function hasRole(r: string): Boolean {
    return keycloak.hasRealmRole(r) || keycloak.hasRealmRole("Admin");
  }

  function getDeviceRoles(type: string): any {
    const map = ROLES.account.device;
    switch (type) {
      case ROUTE_START:
        return map.inbound.roles;
      case MATCH_START:
        return map.outbound.roles;
      case SUB_FLOW:
        return map.subflow.roles;
      case PLAY:
        return map.play.roles;
      case SAY:
        return map.say.roles;
      case REMOTE:
        return map.remote.roles;
      case SIP:
        return map.sipExtension.roles;
      case SIP_GATEWAY:
        return map.sipGateway.roles;
      case CLIENT:
        return map.client.roles;
      case TEAM:
        return map.teams.roles;
      case HUNT_GROUP:
        return map.huntGroup.roles;
      case QUEUE:
        return map.queue.roles;
      case ANI_ROUTER:
        return map.aniRouter.roles;
      case DNIS_ROUTER:
        return map.dnisRouter.roles;
      case ZONE_ROUTER:
        return map.regionRouter.roles;
      case NUMBER_PLAN:
        return map.digits.roles;
      case DAY_OF_WEEK_ROUTER:
        return map.dayOfWeek.roles;
      case DATE_RANGE_ROUTER:
        return map.dateRange.roles;
      case TIME_RANGE_ROUTER:
        return map.timeRange.roles;
      case PLUGIN:
        return map.plugin.roles;
      case SCRIPT:
        return map.script.roles;
      case VOICEMAIL:
        return map.voicemail.roles;
    }
    return "lkfvnlkf";
  }

  return { hasRole, getDeviceRoles, roles: ROLES };
}
